import api from '@/apis/di/budgetSourcePropertyApi';
import CrudCache from '@/stores/crudBaseCache';
var crud = new CrudCache('budgetSourceProperty', api);

const state = {
  ...crud.state,
  _config: {
    table: 'di_budget_source_property',
    field: {
      key: 'budget_source_property_id',
      code: 'budget_source_property_code',
      name: 'budget_source_property_name',
      quickFollow: 'inactive',
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
